import React, { useState, useEffect } from "react";
import ContentWrapper from "../utilities/ContentWrapper";
import ViewReferralTable from "./ViewReferralTable";
import { useDispatch, useSelector } from "react-redux";
import { fetchReferrals } from "../../store/actions/adminActions";
import { Button, Table } from "react-bootstrap";

function ReferralTable() {
	const [showDetail, setShowDetail] = useState(false);
	const [sortConfig, setSortConfig] = useState({ key: "referrals", direction: "descending" });
	const { referrals } = useSelector((state) => state.admin);
	const dispatch = useDispatch();
	const [data, setData] = useState([]);

	useEffect(() => {
		dispatch(fetchReferrals());
	}, [dispatch]);

	useEffect(() => {
		if (referrals?.referrals) {
			const processedData = referrals.referrals.map((ref, index) => ({
				...ref,
				serial: index + 1,
				name: ref.userId?.name,
				referrals: ref.referedUsers?.length
			}));

			// Initially sort by referrals count (descending)
			setData(processedData);
		}
	}, [referrals]);

	const requestSort = (key) => {
		let direction = 'ascending';
		if (sortConfig.key === key && sortConfig.direction === 'ascending') {
			direction = 'descending';
		}
		setSortConfig({ key, direction });
	};

	const getSortedData = () => {
		if (!data.length) return [];

		return [...data].sort((a, b) => {
			if (a[sortConfig.key] < b[sortConfig.key]) {
				return sortConfig.direction === 'ascending' ? -1 : 1;
			}
			if (a[sortConfig.key] > b[sortConfig.key]) {
				return sortConfig.direction === 'ascending' ? 1 : -1;
			}
			return 0;
		});
	};

	const columns = [
		{
			dataField: "serial",
			text: "#",
			width: "20px",
			sortable: false
		},
		{
			dataField: "name",
			text: "Name",
			width: "70px",
			sortable: true
		},
		{
			dataField: "referrals",
			text: "Number of Referrals",
			width: "70px",
			sortable: true
		}
	];

	const exportToCSV = () => {
		const csvContent = [
			columns.map(col => col.text), // Header row
			...getSortedData().map(row => columns.map(col => row[col.dataField] || ''))
		].map(row => row.join(','));

		const blob = new Blob([csvContent.join('\n')], { type: 'text/csv;charset=utf-8;' });
		const link = document.createElement('a');
		const url = URL.createObjectURL(blob);

		link.setAttribute('href', url);
		link.setAttribute('download', 'referrals.csv');
		link.style.visibility = 'hidden';

		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	};

	return (
		<ContentWrapper>
			<div className="card">
				<div className="card-header">
					<h3 className="card-title">REFERRAL TABLES</h3>
				</div>
				<div className="col-md-3" style={{ margin: "10px" }}>
					<Button
						variant="success"
						size="lg"
						onClick={() => setShowDetail(!showDetail)}
					>
						{!showDetail ? "Detailed View" : "Less Details"}
					</Button>
				</div>

				{!showDetail ? (
					<section className="content pb-3">
						<div className="card-body">
							<div style={{ textAlign: "right", marginBottom: "15px" }}>
								<Button variant="primary" size="lg" onClick={exportToCSV}>
									Export To CSV
								</Button>
							</div>
							<hr />
							<div className="table-responsive">
								<Table striped hover>
									<thead>
										<tr>
											{columns.map(column => (
												<th
													key={column.dataField}
													style={{
														backgroundColor: "#c8e6c9",
														width: column.width,
														cursor: column.sortable ? 'pointer' : 'default'
													}}
													onClick={() => column.sortable ? requestSort(column.dataField) : null}
												>
													{column.text}
													{sortConfig.key === column.dataField && (
														<span className="ms-1">
															{sortConfig.direction === 'ascending' ? '▲' : '▼'}
														</span>
													)}
												</th>
											))}
										</tr>
									</thead>
									<tbody>
										{getSortedData().map((row) => (
											<tr key={row._id}>
												{columns.map(column => (
													<td key={`${row._id}-${column.dataField}`}>
														{row[column.dataField]}
													</td>
												))}
											</tr>
										))}
									</tbody>
								</Table>
							</div>
						</div>
					</section>
				) : (
					<ViewReferralTable />
				)}
			</div>
		</ContentWrapper>
	);
}

export default ReferralTable;